import { render, staticRenderFns } from "./BankDetails.vue?vue&type=template&id=50a6c45a&scoped=true"
import script from "./BankDetails.vue?vue&type=script&lang=js"
export * from "./BankDetails.vue?vue&type=script&lang=js"
import style0 from "./BankDetails.vue?vue&type=style&index=0&id=50a6c45a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50a6c45a",
  null
  
)

export default component.exports